export class TreasuryFullModuleTransferDetailDto {
  referenceId: number;
  description: string;
  date: Date;
  amount: number;
}

export class TreasuryFullModuleTransferDetailResponseDto {
  items: TreasuryFullModuleTransferDetailDto[];
  meta?: any;
  links?: any;
}
